// extracted by mini-css-extract-plugin
module.exports = {"ManageReqs":"_2eLYdy8Z","requisitionsTable":"SYfoxdC9","requisitionFilters":"BRB-dRDz","newReqButton":"_1qFxGeCz","manageReqsMainContent":"x2vSz9WF","requisitionHeader":"_3IG2n8jc","reqHeaderBold":"YUor8nzz","reqHeaderText":"_2EsvRZw-"};
    if(module.hot) {
      // 1746735762580
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  